export function replacePlaceholderWithSlots(message, slots) {
  const tokens = [];
  let text = "";
  let position = 0;
  while (position < message.length) {
    const character = message[position];
    switch (character) {
      case "{":
        tokens.push(text);
        text = "";
        break;
      case "}":
        {
          const slotKey = text.split(",")[0].trim();
          tokens.push(slots[slotKey]);
        }
        text = "";
        break;
      default:
        text += character;
        break;
    }
    position += 1;
  }
  tokens.push(text);
  return tokens.filter(Boolean);
}
